export const searchCandidateBatchGroups = (
  candidateBatchGroups: any[] | null | undefined,
  searchValue: string
) => {
  if (!candidateBatchGroups || !searchValue.trim()) {
    return candidateBatchGroups || [];
  }

  return candidateBatchGroups.filter((ruleset) =>
    ruleset.name.toLowerCase().includes(searchValue.toLowerCase())
  );
};
